import ButtonLink from '../../../components/Button/ButtonLink';
import ListItemHeading from '../../../components/ListItemHeading';
import { Paragraph } from '../../../components/Text';

import style from './solution.module.css';

interface ButtonProps {
  target?: null | string;
  title?: null | string;
  url?: null | string;
}

interface SolutionProps {
  button: ButtonProps | null | undefined;
  buttonId: string;
  description: string;
  title: string;
}

const Solution = ({
  button,
  buttonId,
  description,
  title,
}: SolutionProps) => {
  return (
    <article className={style.solution}>
      <div>
        <ListItemHeading className={style.solutionTitle}>
          {title}
        </ListItemHeading>

        <Paragraph fontSize={15}>
          {description}
        </Paragraph>
      </div>

      <ButtonLink
        buttonColor="white"
        className={style.learnMoreButton}
        id={buttonId}
        linkFragment={button}
      />
    </article>
  );
};

export default Solution;
